<template>
  <a class="lxm-contact-item box" @click="clicked">
    <article class="media">
      <figure class="media-left">
        <lxm-avatar :size="'2.5714rem'"
                    :src="avatar"
                    :name="name"
                    :isFemale="isFemale"></lxm-avatar>
      </figure>
      <div class="media-content">
        <div v-if="name" class="lxm-contact-item__name">
          {{ name }}<span v-if="org && org.name" class="not-found">（{{ org.name }}）</span>
        </div>
        <div v-else class="lxm-contact-item__name not-found">
          暂无姓名
        </div>

        <div v-if="phone" class="lxm-contact-item__phone">
          {{ phone }}
        </div>
        <div v-else class="lxm-contact-item__phone not-found">
          暂无手机号
        </div>
      </div>
      <div class="media-right">
        <img class="lxm-contact-item__right-arrow" src="../../images/main/contact/item-right-arrow.png" />
      </div>
    </article>
  </a>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-contact-item
    &.box
      padding: spacing-small spacing spacing
      &:not(:last-child)
        margin-bottom: spacing
    .media-left
      margin-right: spacing-big
  .lxm-contact-item__name
    font-size: size
    line-height: 1
    color: grey-darker
    margin-bottom: spacing-small
  .lxm-contact-item__phone
    font-size: size
    line-height: 1
    color: grey-dark
  .lxm-contact-item__right-arrow
    width: siz(11)
    height: siz(18.5)
    margin-top: siz(10)
</style>

<script>
  import LxmAvatar from './LxmAvatar.vue'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      LxmAvatar
    },
    props: {
      id: {
        type: String,
        default: ''
      },
      avatar: String,
      name: String,
      phone: String,
      isFemale: {
        type: Boolean,
        default: false
      },
      org: Object
    },
    computed: {
    },
    methods: {
      clicked () {
        this.$store.commit(mTypes.TRANSITION_SET_BACK)
        this.$router.push({
          path: '/main/contact/contact/info',
          query: {
            contactId: this.id
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmContactItem.vue?9207d04a